import { render } from "./VUEComponenteGraficoAmpiezza.vue?vue&type=template&id=ba008eea"
import script from "./VUEComponenteGraficoAmpiezza.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoAmpiezza.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__